export type LicenseAvailabilityColor = "green" | "yellow" | "red";

export const AVAILABILITY_COLOR_ORDER: Record<
  LicenseAvailabilityColor,
  number
> = {
  green: 0,
  yellow: 1,
  red: 2,
};

export const getAvailabilityColor = (
  free: number,
  total: number,
): LicenseAvailabilityColor => {
  if (total <= 0) {
    return "red";
  }

  const percent = (free / total) * 100;

  if (percent > 20) {
    return "green";
  }

  if (percent >= 1) {
    return "yellow";
  }

  return "red";
};
